module.exports = __webpack_public_path__ + "img/Endocrinologue.d64967a7.png";